export const environment = {
    production: false,
    apiUrl: 'https://apiidp.dev.bridgefy.com.br/api/v1.0/',
    apiCertificateUrl: 'https://apiidp.dev.bridgefy.com.br/api/v1.0/auth/certificate'
};
